<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-button color="primary"></ion-menu-button>
        </ion-buttons>
        <ion-title>Ship Picture</ion-title>
      </ion-toolbar>
    </ion-header>
    
    <ion-content :fullscreen="true">
      <ion-header collapse="condense">
        <ion-toolbar>
          <ion-title size="large">Ship Picture</ion-title>
        </ion-toolbar>
      </ion-header>
    
      <div id="container">
        <Dropdown @change="companyChanged" v-model="company" :options="companies" optionLabel="name" dataKey="value" placeholder="Company" :required="true" :filter="true" filterPlaceholder="Company" />
        <ion-item>
            <ion-label position="floating">Client <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="action-sheet" @IonChange="clientChanged" v-model="postData['client_id']">
                <ion-select-option v-for="(client,i) of clients" :key="i" :value="client.id">{{client.client_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Ship <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="action-sheet" v-model="postData['ship_id']">
                <ion-select-option v-for="(ship,i) of ships" :key="i" :value="ship.id">{{ship.ship_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <template v-for="(image,i) of postData['ship_image']" :key="i">
            <ion-item>
                <ion-card>
                    <ion-item>
                        <ion-chip slot="end" color="danger" @click="removeImage(i)">
                            <ion-label>Remove</ion-label>
                            <ion-icon :icon="closeCircle"></ion-icon>
                        </ion-chip>
                    </ion-item>

                    <ion-card-content>
                        <ion-img :src="'data:image/jpeg;base64,'+image"></ion-img>
                    </ion-card-content>
                </ion-card>
            </ion-item>
        </template>
        <ion-item>
          <ion-button @click="takePicture()" color="primary">Take Picture</ion-button>
        </ion-item>
        <ion-button expand="block" @click="save()" color="primary">Save</ion-button>
      </div>
    </ion-content>
  </ion-page>
</template>

<script >
import { IonButtons, IonButton, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonItem, IonLabel,IonSelect,IonSelectOption,IonImg, alertController, IonCard, IonCardContent, IonChip, IonIcon } from '@ionic/vue';
import { Camera, CameraResultType } from '@capacitor/camera';
import Loading from '../Loading';
import Dropdown from './modules/Dropdown.vue';
import {closeCircle} from 'ionicons/icons';
export default {
  name: 'Ship Picture',
  data(){
    return {
    companies:[],
    company:'',
    clients:[],
    ships:[],
      postData:{
            'company_id':null,
            'client_id':null,
            'ship_id':null,
            'ship_image':[],
        }
    }
  },
  created(){
    this.$http.get('getCountries',).then(response=>{
      this.countries=response.data;
    });
    this.$http.get('getWorkerPost',).then(response=>{
      this.workerPosts=response.data;
    });
    this.$http.get('getCompany',).then(response=>{
        const coms=[];
        for(const com of response.data){
            coms.push({
                name:com.company_name,
                value:com.id
            });
        }
      this.companies=coms;
    });
  },
  methods:{
      async presentResponseAlert(type,message) {
      const alert = await alertController
        .create({
          header: type+'!',
          // subHeader: 'Subtitle',
          message: message,
          buttons: ['OK'],
        });
      await alert.present();

    },
    async save(){
        const requireds=[
            'company_id',
            'client_id',
            'ship_id',
            'ship_image',
        ];
        for(const required of requireds){
            if(this.postData[required]=='' || this.postData[required]==null){
                let name=required;
                name=name.replace('_id','');
                name=name.replace('_',' ');
                this.presentAlert(name);
                return;
            }
        }
        const data=this.postData;
        data['username'] = window.localStorage.username,
        data['password'] = window.localStorage.password,
      this.$http.post('shipPictureAdd',data).then(response=>{
        if(response.status==200){
            this.postData={
            'company_id':null,
            'client_id':null,
            'ship_id':null,
            'ship_image':[],
        }
        this.company=null;
          this.presentResponseAlert('Success','Ship Picture added Successfully');
          
        }
      });      
    },
    async presentAlert(message) {
      const alert = await alertController
        .create({
          header: 'Alert!',
          // subHeader: 'Subtitle',
          message: message+" is required",
          buttons: ['OK'],
        });
      await alert.present();

    },
   async takePicture() {
      const image = await Camera.getPhoto({
      quality: 90,
      height:720,
      allowEditing: false,
      resultType: CameraResultType.Base64
      });
    this.postData['ship_image'].push(image.base64String);

    },
    removeImage(index){
        const images=[];
        for(const i in this.postData['ship_image']){
            if(i!=index){
                images.push(this.postData['ship_image'][i]);
            }
        }
        this.postData['ship_image']=images;
    },
    async companyChanged(){
        const loading = await Loading.presentLoading('Loading');
        this.postData['company_id']=this.company.value;
        this.postData['client_id']=null;
        this.$http.get('getClient',{params:{id:this.company.value}}).then(response=>{
            this.clients=response.data;
            loading.dismiss();
        });
    },
    async clientChanged(){
        this.postData['ship_id']=null;
        const loading = await Loading.presentLoading('Loading');
        this.$http.get('getShip',{params:{id:this.postData['client_id']}}).then(response=>{
            this.ships=response.data;
            loading.dismiss();
        });
    }
  },
  setup(){
      return {
          closeCircle
      }
  },
  components: {
    IonButtons,
    IonButton,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonItem,
    IonLabel,
    IonSelect,
    IonSelectOption,
    IonImg,
    Dropdown,
    IonCard,
    IonCardContent,
    IonChip,
    IonIcon,
  }
  
}
</script>

<style scoped>
#container {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  /* top: 50%; */
  /* transform: translateY(-50%); */
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  color: #8c8c8c;
  margin: 0;
}

#container a {
  text-decoration: none;
}
.p-dropdown{
width: 100%;
color:#000;
}
.required{
  color:rgb(233, 0, 0)
}
</style>